export const rangeSeparator = '-';
